import React, { Component } from "react";

import DatePicker from "react-date-picker";
import Select from "react-select";
import axios from "axios";
import ReactTable from "react-table";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import { thousands_separators } from "../../components/Methods/Methods";
import {optionsPagesa} from "../../variables/Modal"
import {menyrePagese} from "../../variables/Modal"
import {kodeProdukte} from "../../variables/Modal"
import moment from "moment";
import HmacSHA256 from "crypto-js/hmac-sha256";
import { CSVLink } from "react-csv";


class RaportKomisionDorezime extends Component {
  state = {
    PNga: new Date(),
    PDeri: new Date(),
    date: new Date(),
    posts: [],
    NrPod: "",
    dataPosts: [],
    Id: "",
    Perdorues: { value: "True", label: "Te Gjitha" },
    terminal: [],
    ProcesorId: "",
    selectedOption: null,
    txtAgjensi: true,
    KushPaguan: optionsPagesa[2],
    KodiProduktit: kodeProdukte[4],
    Korrier: { value: "True", label: "Te Gjitha" },
    MenyrePagese: { value: "True", label: "Te Gjitha" },
    Agjensi: window.UserP.agencyId,
    Destinacion: { value: "True", label: "Te Gjitha" },
    KodLevizje: { value: "True", label: "Te Gjitha" },
    Dergues: { value: "True", label: "Te Gjitha" },
    data5: [],
    data7: [],
    Pershkrimi: { value: "True", label: "Te Gjitha" },
    data8: [],
    KlienteSubjekte: { value: "True", label: "Te Gjitha" },
    PerdoruesAgjensi: { value: "True", label: "Te Gjitha" },
    loading: false,
    TotalVleraKomision: "",
    username: window.UserP.username
  };

  handleClear = () => {
    this.setState({
      date: "",
      pDeri: new Date(),
      date: new Date(),
      posts: [],
    });
  };
  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };
  componentDidMount() {
    {
      fetch(window.UserP.url + "POD/GetKodeLevizje", {
        method: "Post",
        headers: {
          Accept: "application/json",
          //"Content-type": "application/json",
          //  "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data5: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKodePershkrimi", {
        method: "Post",
        headers: {
          Accept: "application/json",
          //"Content-type": "application/json",
          //  "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data7: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKlienteSubjekte", {
        method: "Post",
        headers: {
          Accept: "application/json",
          //"Content-type": "application/json",
          //  "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data8: data }));
    }
  }

  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };

  handleChange = (value) => {
    this.setState({
      PNga: value,
    });
  };

  handleChange1 = (value) => {
    this.setState({
      PDeri: value,
    });
  };

  handleClick = (e) => {
    const RaportReq = {
      PNga: moment(this.state.PNga).format("MM/DD/YYYY"),
      PDeri: moment(this.state.PDeri).format("MM/DD/YYYY"),
      // Token: HmacSHA256(
      //   Math.round(new Date().getTime() / 1000).toString(),
      //   window.UserP.key
      // ).toString(),
      // Perdorues: this.state.PerdoruesAgjensi.label,

      Agjensia: window.UserP.agencyId,
      PerdoruesAgjensi: this.state.PerdoruesAgjensi.label,
      // Terminal: window.UserP.terminalId,
      KodLevizje: this.state.KodLevizje.label,
      Pershkrimi: this.state.Pershkrimi.label,
      KodiProduktit: this.state.KodiProduktit.label,
      KushPaguan: this.state.KushPaguan.label,
      MenyrePagese: this.state.MenyrePagese.label,

      KlienteSubjekte: this.state.KlienteSubjekte.label,
    };
 
    this.setState({ loading: true }, () => {
      axios
        .post(window.UserP.url + "POD/KomisionDorezim", RaportReq)
        .then((response) => {
          this.setState({
            loading: false,
            posts: response.data,
          });
          let valueAdded = 0;
          let nr = 0;

          for (var i = 0; i < this.state.posts.length; i++) {
            valueAdded += parseFloat(this.state.posts[i].Komisioni);
            nr += parseFloat("1");
          }

          this.setState({
            TotalVleraKomision: thousands_separators(valueAdded.toFixed(2)),
            nrCope: nr,
          });
        });

   
    });
  };

  printfunction = () => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
    );

    var b = "&nbsp";
    let test = this.state.posts;

    var test5 =
      "&nbsp" +
      "<tr>" +
      "<th >" +
      "Agjensia: " +
      window.UserP.agencyId +
      "<br>" +
      "Terminal:" +
      window.UserP.idProcesori +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "&nbsp" +
      "Periudha: " +
      this.state.PNga.toLocaleDateString() +
      "___" +
      this.state.PDeri.toLocaleDateString() +
      "</th>" +
      "<br>" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<thead>" +
      "<tr>" +
      "<th class='cell'>" +
      "Nr_POD" +
      "</th>" +
      " <th class='cell'>" +
      "Pershkrimi" +
      "</th>" +
      "<th class='-cell'>" +
      "Kod_Levizje" +
      "</th>" +
      "<th class='-cell'>" +
      "Kush_Paguan" +
      "</th>" +
      "<th class='-cell'>" +
      "Origjina" +
      "</th>" +
      "<th class='-cell'>" +
      "Data" +
      "</th>" +
      "<th class='-cell'>" +
      "Menyre_Pagese" +
      "</th>" +
      "<th class='-cell'>" +
      "Kodi_Produktit" +
      "</th>" +
      "<th class='-cell'>" +
      "Kliente_Subjekte_Dergues" +
      "</th>" +
      "<th class='-cell'>" +
      "Kliente_Subjekte_Marres" +
      "</th>" +
      "<th class='-cell'>" +
      "Agjensia_Dorezuese" +
      "</th>" +
      "<th class='-cell'>" +
      "Cmimi_Baze" +
      "</th>" +
      "<th class='-cell'>" +
      "Totali" +
      "</th>" +
      "<th class='-cell'>" +
      "Komisioni" +
      "</th>" +
      "  </tr>" +
      "  </thead>";

    for (var i = 0; i < test.length; i++) {
      test5 +=
        "  <tbody>" +
        "<tr class='firstRow'>" +
        "<td class='Nr_POD:-cell'>" +
        test[i].Nr_POD +
        "</td>" +
        " <td class='Pershkrimi:-cell'>" +
        test[i].Pershkrimi +
        "</td>" +
        " <td class='Kod_Levizje:-cell'>" +
        test[i].Kod_Levizje +
        "</td>" +
        " <td class='Kush_Paguan:-cell'>" +
        test[i].Kush_Paguan +
        "</td>" +
        " <td class='Origjina:-cell'>" +
        test[i].Origjina +
        "</td>" +
        " <td class='Data:-cell'>" +
        test[i].Data +
        "</td>" +
        " <td class='Menyre_Pagese:-cell'>" +
        test[i].Menyre_Pagese +
        "</td>" +
        " <td class='Kodi_Produktit:-cell'>" +
        test[i].Kodi_Produktit +
        "</td>" +
        " <td class='Kliente_Subjekte_Dergues:-cell'>" +
        test[i].Kliente_Subjekte_Dergues +
        "</td>" +
        " <td class='Kliente_Subjekte_Marres:-cell'>" +
        test[i].Kliente_Subjekte_Marres +
        "</td>" +
        " <td class='Agjensia_Dorezuese:-cell'>" +
        test[i].Agjensia_Dorezuese +
        "</td>" +
        " <td class='Cmimi_Baze:-cell'>" +
        test[i].Cmimi_Baze +
        "</td>" +
        " <td class='Totali:-cell'>" +
        test[i].Totali +
        "</td>" +
        " <td class='Komisioni:-cell'>" +
        test[i].Komisioni +
        "</td>" +
        "   </tr>" +
        "&nbsp" +
        "&nbsp" +
        "</tr>";
    }

    test5 +=
      "</table><br>" +
      "Total Komisioni: " +
      this.state.TotalVleraKomision +
      Array(46)
        .fill("&nbsp")
        .join("") +
      "</tbody></font>";
    myWindow.document.write(test5);

    myWindow.focus();

    myWindow.print();
  };

  onChangeFunc = (name) => (value) => {
    // console.log(value.label);
    this.setState({
      [name]: value,
    });
  };

  render() {
    const columns = [
      {
        Header: "Nr",

        id: "row",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },

      {
        Header: "Nr.POD",
        accessor: "Nr_POD",
      },

      {
        Header: "Pershkrimi",
        accessor: "Pershkrimi",
      },

      {
        Header: "Kod_Levizje",
        accessor: "Kod_Levizje",
      },

      {
        Header: "Kush_Paguan",
        accessor: "Kush_Paguan",
      },
      {
        Header: "Origjina",
        accessor: "Origjina",
      },

      {
        Header: "Data",
        accessor: "Data",
      },
      {
        Header: "Menyre_Pagese",
        accessor: "Menyre_Pagese",
      },

      {
        Header: "Kodi_Produktit",
        accessor: "Kodi_Produktit",
      },
      {
        Header: "Kliente Subjekte Dergues",
        accessor: "Kliente_Subjekte_Dergues",
      },
      {
        Header: "Kliente Subjekte Marres",
        accessor: "Kliente_Subjekte_Marres",
      },

      {
        Header: "Agjensia Dorezuese",
        accessor: "Agjensia_Dorezuese",
      },
      {
        Header: "Cmimi Baze",
        accessor: "Cmimi_Baze",
      },
      {
        Header: "Totali",
        accessor: "Totali",
      },
      {
        Header: "Komisioni",
        accessor: "Komisioni",
      },
    ];

    return (
      <div className="Form">
        <div className="card card-body bg-light col-md-12">
          <div className="row ">
            <div className="col-md-2">
              <label>Origjina</label>
            </div>
            <div className="col-md-3">
              <input
                className="form-control"
                value={this.state.Agjensi}
                type="text"
                disabled={this.state.txtAgjensi}
              />
            </div>

            <div className="col-md-2">
              <label> Kush Paguan</label>
            </div>
            <div className="col-md-3">
              <Select
                className="custom-Select"
                onChange={this.onChangeFunc("KushPaguan")}
                options={optionsPagesa}
                defaultValue={optionsPagesa[2]}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Kodi Levizjes</label>
            </div>
            <div className="col-md-3">
              <Select
                onChange={this.onChangeFunc("KodLevizje")}
                options={this.convertToDropDown(this.state.data5)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label>Kliente Subjekte</label>
            </div>
            <div className="col-md-3">
              <Select
                className="custom-Select"
                //value={this.state.kushPaguan}
                onChange={this.onChangeFunc("KlienteSubjekte")}
                options={this.convertToDropDown(this.state.data8)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Nga</label>
            </div>
            <div className="col-md-3">
              <DatePicker
                onChange={this.handleChange}
                value={this.state.PNga}
                name="PNga"
                dateFormat="Pp"
              />
            </div>
            <div className="col-md-2 ">
              <label className="">Deri</label>
            </div>
            <div className="col-md-2 ">
              <DatePicker
                onChange={this.handleChange1}
                value={this.state.PDeri}
                name="PDeri"
                dateFormat="Pp"
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-6">
              <button
                onClick={() => this.handleClick()}
                className="btn btn-primary "
              >
                <span data-notify="icon" className="pe-7s-search" />
                &nbsp; Kerko
              </button>
              <button
                onClick={() => this.printfunction()}
                className="btn btn-primary float-right "
              >
                <span data-notify="icon" className="pe-7s-print" />
                &nbsp; Printo
              </button>

              <CSVLink data={this.state.posts}>
                 <span data-notify="icon" className="pe-7s-download" />
                 &nbsp; Eksporto
               </CSVLink> 
            </div>
            <div className="col-md-6">
              <button
                className="btn btn-primary float-right"
                // type="submit"
                onClick={this.handleClear}
              >
                <span data-notify="icon" className="pe-7s-trash" />
                &nbsp; Pastro
              </button>
            </div>
          </div>
          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <div className="row mt-2">
              <div className="col-md-12 ">
                <ReactTable
                  columns={columns}
                  data={this.state.posts}
                  defaultPageSize={5}
                  className="-striped -highlight mt-4"
                  pageText="Faqe"
                  nextText="Para"
                  rowsText="Rreshta"
                  previousText="Mbrapa"
                  noDataText="Nuk ka te dhena"
                />
              </div>
              <label className="col-md-3">
                Komisioni: {this.state.TotalVleraKomision}
              </label>
              <label className="col-md-3">Cope: {this.state.nrCope}</label>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default RaportKomisionDorezime;
